import React, { useState } from 'react';
import { Grid, Button, Typography, Box, Chip } from '@material-ui/core';

import CollapseCard from '../../../components/Cards/CollapseCard';
import SuspensionModal from '../../../components/SuspensionModal';
import IconWithPopUp from '../../../components/IconWithPopUp';
import useStyles from './styles';

const SuspensionCard = ({
  isSuspended,
  suspensionReason,
  suspensionContactInfo,
  handleSuspend,
  handleReactivate,
  updating,
  isOwner = false,
}) => {
  const classes = useStyles();
  const [suspensionModalOpen, setSuspensionModalOpen] = useState(false);

  const handleSuspendSubmit = ({ reason, coordinatorUserId }) => {
    handleSuspend({ reason, coordinatorUserId });
    setSuspensionModalOpen(false);
  };

  const handleReactivateClick = () => {
    handleReactivate();
  };

  return (
    <>
      <CollapseCard title="Suspension">
        <Grid item xs={12} className={classes.container}>
          {isSuspended && (
            <Box mb={isOwner ? 0 : 2}>
              <Box mb={1.5} display="flex" alignItems="center">
                <Typography variant="body2" className={classes.label}>
                  Status:
                </Typography>
                <Box ml={1}>
                  <Chip label="Suspended" color="secondary" size="small" />
                </Box>
              </Box>
              <Box mb={1.5}>
                <Typography variant="body2" component="span" className={classes.label}>
                  Reason:{' '}
                </Typography>
                <Typography variant="body2" component="span" className={classes.value}>
                  {suspensionReason}
                </Typography>
              </Box>
              <Box mb={isOwner ? 0 : 2}>
                <Typography variant="body2" component="span" className={classes.label}>
                  Contact:{' '}
                </Typography>
                <Typography variant="body2" component="span" className={classes.value}>
                  {suspensionContactInfo}
                </Typography>
              </Box>
            </Box>
          )}

          {!isOwner && (
            <Box>
              {isSuspended ? (
                <IconWithPopUp
                  handler={handleReactivateClick}
                  title="Are you sure you want to reactivate this contractor?"
                  tooltipTitle="Reactivate"
                >
                  <Button variant="contained" color="primary" fullWidth disabled={updating}>
                    Reactivate Contractor
                  </Button>
                </IconWithPopUp>
              ) : (
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={() => setSuspensionModalOpen(true)}
                  disabled={updating}
                >
                  Suspend Contractor
                </Button>
              )}
            </Box>
          )}
        </Grid>
      </CollapseCard>

      <SuspensionModal
        open={suspensionModalOpen}
        onClose={() => setSuspensionModalOpen(false)}
        onSubmit={handleSuspendSubmit}
        loading={updating}
      />
    </>
  );
};

export default SuspensionCard;
